export default __webpack_public_path__ + "static/media/mobile_step_1_Cn.66d959d5.jpg";